exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-content {\n  max-height: 95vh; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/cuentas/new-etiqueta/new-etiqueta.component.scss
// module id = ../../../../../src/app/components/cuentas/new-etiqueta/new-etiqueta.component.scss
// module chunks = 0